import { defineField, defineType } from 'sanity'

export default defineType({
  title: 'Graphs',
  name: 'graphs',
  type: 'object',
  fields: [
    defineField({
      title: 'Legend',
      name: 'legend',
      type: 'array',
      of: [{ title: 'Name', name: 'name', type: 'string' }],
      validation: (rule) => rule.min(2).max(2),
    }),
    defineField({
      title: 'Rows',
      name: 'data',
      type: 'array',
      of: [
        {
          title: 'Row',
          name: 'row',
          type: 'object',
          fields: [
            defineField({
              title: 'Title',
              name: 'title',
              type: 'string',
            }),
            defineField({
              title: 'Bars',
              name: 'bars',
              type: 'array',
              of: [
                {
                  title: 'Bar',
                  name: 'bar',
                  type: 'object',
                  fields: [
                    defineField({
                      title: 'Label',
                      name: 'label',
                      type: 'string',
                    }),
                    defineField({
                      title: 'Percentage',
                      name: 'percentage',
                      type: 'number',
                      validation: (rule) =>
                        rule.integer().positive().min(1).max(100),
                    }),
                  ],
                  preview: {
                    select: {
                      label: 'label',
                      percentage: 'percentage',
                    },
                    prepare(selection) {
                      const { label = 'New item...', percentage = 0 } =
                        selection
                      return {
                        title: label,
                        subtitle: `${percentage}%`,
                      }
                    },
                  },
                },
              ],
              validation: (rule) => rule.min(2).max(2),
            }),
          ],
          preview: {
            select: {
              title: 'title',
            },
            prepare(selection) {
              const { title = 'Add item' } = selection || {}

              return {
                title,
                subtitle: '',
              }
            },
          },
        },
      ],
    }),
  ],
})